// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"44":"14ac0b92","94":"62658972","222":"1490ebca","243":"3dce5ab0","550":"8b5e5ced","754":"6d6cd46a","767":"a6d9c171","795":"17b0329e","820":"e8d38440","895":"3f439587"}[chunkId] + ".js";
};